import React, { Component } from 'react'
import Paper from '@mui/material/Paper';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { CANDIDATE_ACTIVITY_TABS, RECRUITER_ACTIVITY_TABS, CANDIDATE_ACTIVITY_SUB_TYPES, RECRUITER_ACTIVITY_SUB_TYPES } from '../utils/utils';

export default class HistTabs extends Component {
    handleChange = (event, value) => {
        const {histogramType, lookingforwork, goToRoute} = this.props
        const keys = (lookingforwork) ? CANDIDATE_ACTIVITY_SUB_TYPES : RECRUITER_ACTIVITY_SUB_TYPES;

        goToRoute('/' + histogramType + '/' + keys[value])
    };

    render() {
        const {histogramType, histogramSubType, lookingforwork, isFetching, isAuthed, hasJobsSuggestion, hasMatchesCan, hasApplicants, hasMatchesRec} = this.props
        let showBadgesOnTabs = []

        if(isAuthed){
            if(lookingforwork) {
                showBadgesOnTabs = [false, hasJobsSuggestion, hasMatchesCan]
            } else {
                showBadgesOnTabs = [false, hasApplicants, hasMatchesRec]
            }
        }

        const tabs = (lookingforwork) ? CANDIDATE_ACTIVITY_TABS : RECRUITER_ACTIVITY_TABS
        const keys = (lookingforwork) ? CANDIDATE_ACTIVITY_SUB_TYPES : RECRUITER_ACTIVITY_SUB_TYPES;

        const currntTab = keys.indexOf(histogramSubType)

        return (
            <React.Fragment>
                {(histogramType === 'activity')&&<Paper elevation={2} square>
                    <Tabs
                        value={(currntTab === -1) ? 0 : currntTab}
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={this.handleChange}
                        variant="scrollable"
                        scrollButtons={false}
                    >
                        {tabs.map((tab, index) => 
                            <Tab label={<span>{tab}{(showBadgesOnTabs[index] !== undefined && showBadgesOnTabs[index])&&<div className="JSBadge" style={{right:2}}></div>}</span>}
                                key={tab}
                                className="histTab"
                                disabled={isFetching}/>)
                        }
                    </Tabs>
                </Paper>}
            </React.Fragment>
        );
    }
}